import axios from "axios";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";
import AdminAutoComplete from "../AdminAutoComplete";

const EditPostSite = (props) => {

    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [isDisplayed, setIsDisplayed] = useState(false);

    const [image, setImage] = useState([]);
    const [video, setVideo] = useState([]);
    const [document, setDocument] = useState([]);
    const [addressValue, setAddressValue] = useState();

    const [addressLocation, setAddressLocation] = useState();

    const [errorlist, setError] = useState([])
    const userId = localStorage.getItem('user_id');

    const [loader, showLoader, hideLoader] = UseFullPageLoader();



    useEffect(() => {
        setInterval(() => {
            setIsDisplayed(true);
        }, 1200);
      }, []);
    
    document.title = "DirtMap - Edit Listing";

    const [postSiteInput, setPostSiteInput] = useState({
        user_id: localStorage.getItem('user_id') ? localStorage.getItem('user_id') : 0,
        item_type: '',
        project_name: '',
        cuyds_of_dirt_min: '',
        cuyds_of_dirt_max: '',
        address: '',
        latitude: '',
        longitude: '',
        description: '',
        special_instruction: '',
        name: '',
        email: '',
        phone: '',
        status: ''
    });


    const handleInput = (e) => {
        e.persist();
        setPostSiteInput({ ...postSiteInput, [e.target.name]: e.target.value });
    }

    const handleImage = (e) => {
        e.persist();
        console.log(e.target.files);
        setImage({ image: e.target.files });
    }
    const handleVideo = (e) => {
        e.persist();
        setVideo({ video: e.target.files[0] });
    }
    const handleDocument = (e) => {
        e.persist();
        setDocument({ document: e.target.files[0] });
    }

    const setCoodinationValue = (value, ll) => {
        
        postSiteInput.address = value;
        postSiteInput.latitude = ll.lat;
        postSiteInput.longitude = ll.lng;
        setAddressValue(value);
         console.log(value);
        // console.log(ll.lat);
        // console.log(ll.lng);
    
      }


    useEffect(() => {
        const postId = props.match.params.id;

        axios.get(`api/detail/post/site/${postId}/${userId}`).then(res => {
            if (res.data.result) {
                setPostSiteInput(res.data.result);
                setAddressLocation(res.data.result);
            } else if (res.data.success === false) {
                swal("warning", res.data.message, "error");
                history.push('/list/post/site');
            }
            setLoading(false);
        });

    }, [props.match.params.id,userId, history]);

    if (loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;

    } 

    const updatePostSite = (e) => {
        e.preventDefault();
        const postId = props.match.params.id;

        const formData = new FormData();

        if(image.image && image.image.length > 0){
            //formData.append('image', image.image);
            for (let i = 0; i < image.image.length; i++) {
               // console.log(i);
                ///console.log(image.image.length);
                formData.append(`image[${i}]`, image.image[i])
            }
        }

        if(document.document == ""){
            formData.append('document', document.document);
        }
        if(video.video == ""){
            formData.append('video', video.video);
        }

        formData.append('user_id', userId);
        formData.append('email', postSiteInput.email);
        formData.append('item_type', postSiteInput.item_type);
        formData.append('project_name', postSiteInput.project_name);
        formData.append('cuyds_of_dirt_min', postSiteInput.cuyds_of_dirt_min);
        formData.append('cuyds_of_dirt_max', postSiteInput.cuyds_of_dirt_max);
        formData.append('address', postSiteInput.address);
        formData.append('latitude', postSiteInput.latitude);
        formData.append('longitude', postSiteInput.longitude);
        formData.append('description', postSiteInput.description);
        formData.append('special_instruction', postSiteInput.special_instruction);
        formData.append('name', postSiteInput.name);
        formData.append('email', postSiteInput.email);
        formData.append('phone', postSiteInput.phone);
        formData.append('status', postSiteInput.status);

        console.log(document.document);
        console.log(postSiteInput);

        


        showLoader();
        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post(`/api/update/post/site/${postId}/${userId}`, formData).then(res => {
                if (res.data.success === true) {
                    console.log('success')
                    hideLoader();
                    swal("success", res.data.message, "success");
                    history.push('/admin/post-site/index');
                    setError([]);
                }
                else {
                    hideLoader();

                    console.log(res.data);

                    setError(res.data.errors);
                    //setPostSiteInput({ ...postSiteInput, error_list: res.data.errors });
                }
            });
        });
    }


    return (
        <div className="container-fluid">
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h4 className="card-title mb-0">Edit Listings</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={updatePostSite}>

                    <input type="hidden" id="__postSearchLocationAdress" name="address" onChange={handleInput} value={addressValue ? addressValue : postSiteInput.address} />
                    <input type="hidden" id="__postLatitude" name="latitude" onChange={handleInput} value={postSiteInput.latitude} />
                    <input type="hidden" id="__postLongitude" name="longitude" onChange={handleInput} value={postSiteInput.longitude} />
                    
                    <input type="hidden" name="user_id" onChange={handleInput} value={userId}  />

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Item Type</label>

                                    <select name="item_type" onChange={handleInput} value={postSiteInput.item_type} className="form-control">
                                        <option value="">Select Item Type</option>
                                        <option value="export" selected={postSiteInput.item_type == 'export' ? 'selected' : ''}>Export</option>
                                        <option value="import" selected={postSiteInput.item_type == 'import' ? 'selected' : ''}>Import</option>
                                        <option value="dump_site" selected={postSiteInput.item_type == 'dump_site' ? 'selected' : ''}>Dump Site</option>
                                        <option value="truks" selected={postSiteInput.item_type == 'truks' ? 'selected' : ''}>Truks</option>


                                    </select>
                                    {/* <span className="validate-error-message">{errorlist.item_type}</span> */}

                                </div>
                            </div>
                      
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Project Name</label>
                                    <input type="text" name="project_name" onChange={handleInput} value={postSiteInput.project_name} className="form-control" placeholder="Enter Project Name" />
                                    <span className="validate-error-message">{errorlist.project_name}</span>
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <div className="form-group">
                                    <label>Cuyds Of Dirt</label>
                                    <input type="text" name="cuyds_of_dirt_min" onChange={handleInput} value={postSiteInput.cuyds_of_dirt_min} className="form-control" placeholder="Enter Cuyds Of Dirt" />
                                    <span className="validate-error-message">{errorlist.cuyds_of_dirt_min}</span>
                                </div>
                            </div> */}

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="userName">CuYds Of Dirt Min</label>
                                    <input type="text" name="cuyds_of_dirt_min" onChange={handleInput} value={postSiteInput.cuyds_of_dirt_min} className="form-control" placeholder="Enter CuYds Of Dirt Min" />
                                    <span className="validate-error-message">{errorlist.cuyds_of_dirt_min}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="email">CuYds Of Dirt Max</label>
                                    <input type="text" name="cuyds_of_dirt_max" onChange={handleInput} value={postSiteInput.cuyds_of_dirt_max} className="form-control" placeholder="Enter CuYds Of Dirt Max" />
                                    <span className="validate-error-message">{errorlist.cuyds_of_dirt_max}</span>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Address</label>
                                   
                                    {/* <input type="text" name="address" onChange={handleInput} value={postSiteInput.address} className="form-control" placeholder="Enter Address" /> */}
                                    {isDisplayed &&
                                        <AdminAutoComplete 
                                        apiKey={'AIzaSyCv7m-2LTrrKnu1P38xKNBvvFJXoQGAnGg'}
                                        setCoodinationValue={setCoodinationValue}
                                        addressLocation={addressLocation}
                                        />
                                    } 

                                    <span className="validate-error-message">{errorlist.address}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Description</label>
                                    <textarea type="text" name="description" onChange={handleInput} value={postSiteInput.description} className="form-control" placeholder="Enter Description" />
                                    <span className="validate-error-message">{errorlist.description}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Image</label>
                                    <input type="file" multiple name="image" onChange={handleImage} className="form-control" multiple  accept="image/*"/>
                                    <span className="validate-error-message">{errorlist.image}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Video</label>
                                    <input type="file" name="video" onChange={handleVideo}  className="form-control" />
                                    <span className="validate-error-message">{errorlist.video}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Document</label>
                                    <input type="file" name="document" onChange={handleDocument}  className="form-control" />
                                    <span className="validate-error-message">{errorlist.document}</span>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Special Instruction</label>
                                    <textarea type="text" name="special_instruction" onChange={handleInput} value={postSiteInput.special_instruction} className="form-control" placeholder="Enter Special Instruction" />
                                    <span className="validate-error-message">{errorlist.special_instruction}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Name</label>
                                    <input type="text" name="name" onChange={handleInput} value={postSiteInput.name} className="form-control" placeholder="Enter Name" />
                                    <span className="validate-error-message">{errorlist.name}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Email</label>
                                    <input type="text" name="email" onChange={handleInput} value={postSiteInput.email} className="form-control" placeholder="Enter Email" />
                                    <span className="validate-error-message">{errorlist.email}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Phone Number</label>
                                    <input type="text" name="phone" onChange={handleInput} value={postSiteInput.phone} className="form-control" placeholder="Enter Phone Number" />
                                    <span className="validate-error-message">{errorlist.phone}</span>
                                </div>
                            </div>
                            <div className="col-md-6 form-check mb-3 ml-2">
                                <input name="status" onChange={handleInput} value={postSiteInput.status} className="form-check-input"  id="inputRememberPassword" type="checkbox" value="1" checked={postSiteInput.status === '1' ? 'checked' : ''} />
                                <label className="form-check-label">Status</label>
                                <span className="validate-error-message">{errorlist.status}</span>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-md-12 text-right">
                                <button type="submit" className="btn btn-primary">Update</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {loader}
        </div>
    );
}
export default EditPostSite;